import { render } from "./AddNewToolItemModalDialog.vue?vue&type=template&id=8a09be76&scoped=true&ts=true&lang=pug"
import script from "./AddNewToolItemModalDialog.vue?vue&type=script&lang=ts"
export * from "./AddNewToolItemModalDialog.vue?vue&type=script&lang=ts"

import "./AddNewToolItemModalDialog.vue?vue&type=style&index=0&id=8a09be76&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a09be76"]])

export default __exports__